import { render, staticRenderFns } from "./DeliveryLocationSelector.vue?vue&type=template&id=4452708b&"
import script from "./DeliveryLocationSelector.vue?vue&type=script&lang=js&"
export * from "./DeliveryLocationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports